<h1 mat-dialog-title i18n>
	Associated legals <small class="align-top">- {{dialogData.appKey.name}}</small>

	<button type="button" mat-icon-button [matMenuTriggerFor]="appKeyMenu" class="app-key-menu-btn">
		<span class="material-icons">more_vert</span>
	</button>
	<mat-menu #appKeyMenu="matMenu" xPosition="before">
		<div class="top-right-drop-menu">
			<button mat-menu-item (click)="openAction(appKeyTableActions.edit)">
				<div class="row px-2">
					<div class="col pl-2"><span>Edit Settings</span></div>
				</div>
			</button>
			<button mat-menu-item (click)="openAction(appKeyTableActions.requiredVersions)">
				<div class="row px-2">
					<div class="col pl-2"><span>View Required Versions</span></div>
				</div>
			</button>
		</div>
	</mat-menu>
</h1>

<div mat-dialog-content class="main-content px-4 pb-2">
	<div class="col-12 px-0 mt-2 mb-0">
		<app-appkey-legals-table
			[company]="dialogData.company"
			[appKey]="dialogData.appKey"
			[terms]="dialogData.terms"
		></app-appkey-legals-table>
	</div>
</div>

<div mat-dialog-actions class="row px-1 mb-0 justify-content-center">
	<div class="col-6 text-center">
		<button
			class="w-100"
			type="button"
			(click)="close()"
			mat-flat-button
			i18n
		>Close</button>
	</div>
</div>
